import * as types from "../actions/types/payroll.types";

const initialState = {
    onboardStatusState: "idle",
    getKudaPayrollState: "idle",
    onboardStatusData: null,
    onboardStatusMessage: "",
    configurations: null,
    configurationsState: "idle",
    configurationsMessage: "",
    employees: [],
    employeesState: "idle",
    employeesMessage: "",
    totalEmployees: 0,
    firstScheduleState: "loading",
    firstSchedules: [],
    schedulesState: "idle",
    schedules: [],
    schedulesMessage: "",
    totalSchedules: 0,
    emloyeesWithoutSchedules: [],
    employeesNoScheduleState: "idle",
    payrollHistoryState: "idle",
    payrollHistory: [],
    totalHistory: 0,
    historyMessage: "",
    historyDetailsState: "idle",
    historyDetails: {},
    setup_Stage: localStorage.getItem("setup_Stage"),
};

export const kudaPayrollReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.ONBOARD_PAYROLL_STARTED:
            return {
                ...state,
                onboardStatusState: "loading",
            };
        case types.ONBOARD_PAYROLL_SUCCESS:
            return {
                ...state,
                onboardStatusState: "success",
                onboardStatusData: action.payload.data,
                onboardStatusMessage: action.payload.message,
            };
        case types.ONBOARD_PAYROLL_FAILED:
            return {
                ...state,
                onboardStatusState: "failed",
                onboardStatusMessage: action.payload.message,
            };
        case types.GET_ONBOARD_STATUS_STARTED:
            return {
                ...state,
                getKudaPayrollState: "loading",
            };
        case types.GET_ONBOARD_STATUS_SUCCESS:
            return {
                ...state,
                getKudaPayrollState: "success",
                onboardStatusData: action.payload.data,
                onboardStatusMessage: action.payload.message,
            };
        case types.GET_ONBOARD_STATUS_FAILED:
            return {
                ...state,
                getKudaPayrollState: "failed",
                onboardStatusMessage: action.payload.message,
            };
        case types.GET_PAYROLL_CONFIGURATION_STARTED:
            return {
                ...state,
                configurationsState: "loading",
            };
        case types.GET_PAYROLL_CONFIGURATION_SUCCESS:
            return {
                ...state,
                configurationsState: "success",
                configurations: action.payload.data,
                configurationsMessage: action.payload.message,
            };
        case types.GET_PAYROLL_CONFIGURATION_FAILED:
            return {
                ...state,
                configurationsState: "failed",
                configurationsMessage: action.payload.message,
            };
        case types.GET_EMPLOYEES_STARTED:
            return {
                ...state,
                employeesState: "loading",
            };
        case types.GET_EMPLOYEES_SUCCESS:
            return {
                ...state,
                employees: action.payload.data,
                employeesMessage: action.payload.message,
                totalEmployees: action.payload.totalCount,
                employeesState: "success",
            };

        case types.GET_EMPLOYEES_FAILED:
            return {
                ...state,
                employeesState: "failed",
                employeesMessage: action.payload.message,
            };
        case types.COMPLETE_ONBOARDING_STARTED:
            return {
                ...state,
                onboardStatusState: "loading",
            };
        case types.COMPLETE_ONBOARDING_SUCCESS:
            return {
                ...state,
                onboardStatusData: action.payload.data,
                onboardStatusMessage: action.payload.message,
            };
        case types.COMPLETE_ONBOARDING_FAILED:
            return {
                ...state,
                onboardStatusState: "failed",
                onboardStatusMessage: action.payload.message,
            };
        case types.GET_FIRST_SCHEDULES_STARTED:
            return {
                ...state,
                firstScheduleState: "loading",
            };
        case types.GET_FIRST_SCHEDULES_SUCCESS:
            return {
                ...state,
                firstSchedules: action.payload.data,
                firstScheduleState: "success",
                totalSchedules: action.payload.totalCount,
                schedulesMessage: action.payload.message,
            };
        case types.GET_FIRST_SCHEDULES_FAILED:
            return {
                ...state,
                firstScheduleState: "failed",
                schedulesMessage: action.payload.message,
            };
        case types.GET_SCHEDULES_STARTED:
            return {
                ...state,
                schedulesState: "loading",
            };
        case types.GET_SCHEDULES_SUCCESS:
            return {
                ...state,
                schedules: action.payload.data,
                schedulesState: "success",
                totalSchedules: action.payload.totalCount,
                schedulesMessage: action.payload.message,
            };
        case types.GET_SCHEDULES_FAILED:
            return {
                ...state,
                schedulesState: "failed",
                schedulesMessage: action.payload.message,
            };
        case types.GET_NOT_ADDED_EMPLOYEES_STARTED:
            return {
                ...state,
                employeesNoScheduleState: "loading",
            };
        case types.GET_NOT_ADDED_EMPLOYEES_SUCCESS:
            return {
                ...state,
                emloyeesWithoutSchedules: action.payload.data,
                employeesNoScheduleState: "success",
            };
        case types.GET_NOT_ADDED_EMPLOYEES_FAILED:
            return {
                ...state,
                employeesNoScheduleState: "failed",
            };
        case types.GET_PAYROLL_HISTORY_STARTED:
            return {
                ...state,
                payrollHistoryState: "loading",
            };
        case types.GET_PAYROLL_HISTORY_SUCCESS:
            return {
                ...state,
                payrollHistory: action.payload.data,
                payrollHistoryState: "success",
                totalHistory: action.payload.totalCount,
                historyMessage: action.payload.message,
            };
        case types.GET_PAYROLL_HISTORY_FAILED:
            return {
                ...state,
                payrollHistoryState: "failed",
                historyMessage: action.payload.message,
            };
        case types.GET_HISTORY_DETAILS_STARTED:
            return {
                ...state,
                historyDetailsState: "loading",
            };
        case types.GET_HISTORY_DETAILS_SUCCESS:
            return {
                ...state,
                historyDetails: action.payload.data,
                historyDetailsState: "success",
                historyMessage: action.payload.message,
            };
        case types.GET_HISTORY_DETAILS_FAILED:
            return {
                ...state,
                historyDetailsState: "failed",
                historyMessage: action.payload.message,
            };

        case types.SET_SETUP_STAGE_SUCCESS:
            return {
                ...state,
                setup_Stage: action.payload,
            };
        default:
            return state;
    }
};
